export const RECEIVE_SPORTS = 'STRUCTURE/RECEIVE_SPORTS';
export const RECEIVE_CATEGORIES = 'STRUCTURE/RECEIVE_CATEGORIES';
export const RECEIVE_TOURNAMENTS = 'STRUCTURE/RECEIVE_TOURNAMENTS';
export const RECEIVE_EVENTS = 'STRUCTURE/RECEIVE_EVENTS';
export const SELECT_SPORT = 'STRUCTURE/SELECT_SPORT';
export const SELECT_CATEGORY = 'STRUCTURE/SELECT_CATEGORY';
export const SELECT_TOURNAMENT = 'STRUCTURE/SELECT_TOURNAMENT';
export const SELECT_EVENT = 'STRUCTURE/SELECT_EVENT';